import {
  CalendarOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  MenuOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';

export const VARIABLE_TYPE_CUSTOM = 'custom';
export const VARIABLE_TYPE_STANDARD = 'standard';

export const STANDARD_VARIABLE_TYPES = {
  PREFIX: 'PREFIX',
  FIRST_NAME: 'FIRST_NAME',
  MIDDLE_NAME: 'MIDDLE_NAME',
  LAST_NAME: 'LAST_NAME',
  SUFFIX: 'SUFFIX',
};

export const STANDARD_VARIABLE_NAMES = {
  [STANDARD_VARIABLE_TYPES.PREFIX]: 'Prefix',
  [STANDARD_VARIABLE_TYPES.FIRST_NAME]: 'First Name',
  [STANDARD_VARIABLE_TYPES.MIDDLE_NAME]: 'Middle Name',
  [STANDARD_VARIABLE_TYPES.LAST_NAME]: 'Last Name',
  [STANDARD_VARIABLE_TYPES.SUFFIX]: 'Suffix',
};

export const CUSTOM_VARIABLE_TYPES = {
  MULTI_LINE_TEXT: 'MULTI_LINE_TEXT',
  SINGLE_CHECK_BOX: 'SINGLE_CHECK_BOX',
  DROPDOWN_SELECT: 'DROPDOWN_SELECT',
  DATE_PICKER: 'DATE_PICKER',
  TIME_PICKER: 'TIME_PICKER',
};

export const CUSTOM_VARIABLE_TYPE_ICONS = {
  [CUSTOM_VARIABLE_TYPES.MULTI_LINE_TEXT]: MenuOutlined,
  [CUSTOM_VARIABLE_TYPES.SINGLE_CHECK_BOX]: CheckSquareOutlined,
  [CUSTOM_VARIABLE_TYPES.DROPDOWN_SELECT]: UnorderedListOutlined,
  [CUSTOM_VARIABLE_TYPES.DATE_PICKER]: CalendarOutlined,
  [CUSTOM_VARIABLE_TYPES.TIME_PICKER]: ClockCircleOutlined,
};

export const STANDARD_VARIABLE_MAPPING = {
  [STANDARD_VARIABLE_TYPES.PREFIX]: {
    label: STANDARD_VARIABLE_NAMES.PREFIX,
    type: VARIABLE_TYPE_STANDARD,
  },
  [STANDARD_VARIABLE_TYPES.FIRST_NAME]: {
    label: STANDARD_VARIABLE_NAMES.FIRST_NAME,
    type: VARIABLE_TYPE_STANDARD,
  },
  [STANDARD_VARIABLE_TYPES.MIDDLE_NAME]: {
    label: STANDARD_VARIABLE_NAMES.MIDDLE_NAME,
    type: VARIABLE_TYPE_STANDARD,
  },
  [STANDARD_VARIABLE_TYPES.LAST_NAME]: {
    label: STANDARD_VARIABLE_NAMES.LAST_NAME,
    type: VARIABLE_TYPE_STANDARD,
  },
  [STANDARD_VARIABLE_TYPES.SUFFIX]: {
    label: STANDARD_VARIABLE_NAMES.SUFFIX,
    type: VARIABLE_TYPE_STANDARD,
  },
};

export const VARIABLE_CLASS_NAMES = {
  PILL: 'variableEmbedPill',
  PILL_STANDARD: 'variableEmbedPill--standard',
  PILL_CUSTOM: 'variableEmbedPill--custom',
  HIGHLIGHT: 'variableEmbedHighlight',
  HIGHLIGHT_STANDARD: 'variableEmbedHighlight--standard',
  HIGHLIGHT_CUSTOM: 'variableEmbedHighlight--custom',
};

// Regex to match variable placeholders in curly brace format
// Matches two patterns:
// 1) Custom variables: {{c:Variable Name:TYPE}} or {{C:Variable Name:TYPE}} - captures type prefix, name, and optional type
// 2) Standard variables: {{VARIABLE_NAME}} - captures the variable name
// Examples: {{c:Custom Variable:DROPDOWN_SELECT}}, {{FIRST_NAME}}
export const VARIABLE_PLACEHOLDER_REGEX = /\{\{([cC]):([a-zA-Z0-9 _-]+)(?::([A-Z_]+))?\}\}|\{\{([A-Z_][A-Z0-9_]*)\}\}/g;

// Regex to match variable pill span elements - finds the opening span tag only
// Input: '<span class="variableEmbedPill variableEmbedPill--standard" translate="no" data-key="FIRST_NAME">'
// Output: match[0] = entire opening span tag (used to locate the element)
export const VARIABLE_PILL_REGEX = /<span[^>]*class="[^"]*variableEmbedPill[^"]*"[^>]*>/i;

// Extracts the variable value from data-key attribute
// Input: 'data-key="FIRST_NAME"' (anywhere in the span)
// Output: match[0] = 'data-key="FIRST_NAME"', match[1] = 'FIRST_NAME' (just the value)
export const DATA_KEY_REGEX = /data-key="([^"]*)"/i;

// Extracts the variable type (standard or custom) from data-type attribute
// Input: span containing: 'data-type="standard"'
// Output: match[0] = 'data-type="standard"', match[1] = 'standard'
export const DATA_TYPE_REGEX = /data-type="([^"]*)"/i;

// Extracts the variable type from data-custom-type attribute
// Input: span containing: 'data-custom-type="MULTI_LINE_TEXT"'
// Output: match[0] = 'data-custom-type="MULTI_LINE_TEXT"', match[1] = 'MULTI_LINE_TEXT'
export const DATA_CUSTOM_TYPE_REGEX = /data-custom-type="([^"]*)"/i;

export const CUSTOM_VARIABLE_NAME_PATTERN = /^[a-zA-Z \d-_]+$/;
export const CUSTOM_VARIABLE_NAME_MAX_LENGTH = 200;
export const CUSTOM_VARIABLE_DROPDOWN_TYPE_MAX_OPTIONS = 50;
export const CUSTOM_VARIABLE_DRAWER_WIDTH = 700;
export const CUSTOM_VARIABLE_DROPDOWN_OPTION_MAX_LENGTH = 1000;

export const VARIABLE_CHARACTER_COUNTS = {
  [VARIABLE_TYPE_STANDARD]: 20,
};
